/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_References_LabelInputs */

const en_cv_extract_form_references_label = /** @type {(inputs: Cv_Extract_Form_References_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`References`)
};

const de_cv_extract_form_references_label = /** @type {(inputs: Cv_Extract_Form_References_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenzen`)
};

/**
* | output |
* | --- |
* | "References" |
*
* @param {Cv_Extract_Form_References_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_extract_form_references_label = /** @type {((inputs?: Cv_Extract_Form_References_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_References_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_references_label(inputs)
	return en_cv_extract_form_references_label(inputs)
});